import posthog from "posthog-js";

export const useTrackingEvent = () => {
  const shouldMockPostHog = posthog.__loaded === false;

  if (shouldMockPostHog) {
    console.warn(
      "PostHog is not initialized. Mocking PostHog for development."
    );
    return {
      capture: (
        event: string,
        properties?: Record<string, any>,
        payload?: Record<string, any>
      ) => {
        console.log(`Mock Event Captured: ${event}`, properties, payload);
      },
      identify: (
        userId: string,
        properties?: Record<string, any>,
        payload?: Record<string, any>
      ) => {
        console.log(`Mock User Identified: ${userId}`, properties, payload);
      },
    };
  }

  return posthog as unknown as {
    capture: (
      event: string,
      properties?: Record<string, any>,
      payload?: Record<string, any>
    ) => void;
    identify: (
      userId: string,
      properties?: Record<string, any>,
      payload?: Record<string, any>
    ) => void;
  };
};
